import React, { useState, useRef, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import _ from "lodash";
import moment from "moment";
import DOMPurify from 'dompurify';
import Parser from 'html-react-parser';


import "../index.css";

import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import { ConfirmPopup } from "primereact/confirmpopup";

import Menu from "../../../helpers/Menu";
import { Button } from "../../../helpers";

import POPunch from "./POPunch";
import NewApprovalsDisplay from "./NewApprovalsDisplay";

import Loading from "../../../common/Loading";
import SendEmail from "../../../common/SendEmail";
import RemarksDialog from "../../../common/RemarksDialog";
import CopyToClipboard from "../../../common/CopyToClipboard";

import { sendEmail } from "../../../services/api/sendEmail";
import { cancelBuyerPO } from "../../../services/api/buyerPO";
import { getDocCopyByDocNo } from "../../../services/api/docCopy";
import { insertProformaInvoice } from "../../../services/api/proformaInvoice";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchApprovalSecondary, fetchApprovalTypes, fetchApprovals, fetchCompanySupplyType, fetchMaterialBrands, fetchStatus } from "../../../services/redux/reducers/commonThunk";

import downloadFile from "../../../utils/DownloadFile";
import { getApprovalRequestStatusDetails, getApprovalStatus, getBuyerPOApprovals, getProductName, getProductQty, getProductSpecification, numberConversion } from "../../../utils";

import { DATE_FORMAT } from "../../../constants";

import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";

import DocumentView from "../../../common/DocumentView";


const BuyerPOView = (props) => {
    const {
        displayTable,
        selectedReq,
        buyerPOId,
        buyerPO,
        buyerPOItems,
        poPunch,
        buyerReq,
        buyerQuote,
        buyerBillAddrDetails,
        materialDetails,
        documentHTML,
        buyerPOPdfURL,
        setBuyerPOPDFURL,
        getBuyerPO,
        approvalInstances,
        setApprovalInstances,
        proformaInvoice,
        setProformaInvoice,
        isLoading,
        setIsLoading
    } = props

    const navigate = useNavigate()

    const [visiblePOPunch, setVisiblePOPunch] = useState(false)
    const [isEmailDialogVisible, setIsEmialDialogVisible] = useState(false)
    const [isReasonDialogVisible, setIsReasonDialogVisible] = useState(false)
    const [buttonClicked, setButtonClicked] = useState(false)
    const [isPDFLoading, setIsPDFLoading] = useState(false)
    const [isProformaInvoiceVisible, setIsProformaInvoiceVisible] = useState(false)
    const [visibleApprovals, setVisibleApprovals] = useState(false)

    const actionMenu = useRef(null)
    const [selectedSupplyTypeId, setSelectedSupplyTypeId] = useState(null)

    const [requiredApprovals, setRequiredApprovals] = useState([])
    const [approvalRequestStatusDetails, setApprovalRequestStatusDetails] = useState([])
    
    const companySupplyTypes = useSelector(state => state.common.companySupplyType)
    const pmUserDetails = useSelector(state => state.userDetails.userNameDetails)
    const approvals = useSelector((state) => state.common.approvals)
    const approvalTypes = useSelector(state => state.common.approvalTypes)
    const materialBrands = useSelector(state => state.common.materialBrands)
    const approvalSecondary = useSelector((state) => state.common.approvalSecondary)

    const dispatch = useDispatch()

    const currentDate = new Date()

    const pmCompanyConfig = getPMCompanyConfig(buyerPO.pmCompanyId)
    let { currencyShortName, numberLocale } = pmCompanyConfig
    
    const emailDetailsObj = {
        to: buyerBillAddrDetails?.email,
        from: "orders@procmart.com",
        kam: pmUserDetails?.emailId,
        subject: `Purchase Order ${buyerBillAddrDetails?.companyName} - ${moment(currentDate).format(DATE_FORMAT)} (${buyerPO?.docNo})`,
        message: `
            <div>
                Dear Sir/Madam,<br/><br/>

                Greetings From ProcMart !!!!<br/><br/>
                
                This mail is with reference to your purchase order number <b>${buyerPO.docNo}</b>.<br/>
                Thank you for the valuable purchase order, we acknowledge the receipt of the purchase order, we have processed the order and the expected delivery timeline is mentioned below.<br/><br/>
                
                <b>Expected Delivery Date</b>: <br/>
                In case of any delay in delivery, we will update you.<br/><br/>
                
                For any further clarifications, you can contact us at below-mentioned number, thanking you and assuring you of our best services at all times.<br/><br/>
                
                ${pmUserDetails?.firstName} ${pmUserDetails?.lastName}<br/>
                ${pmUserDetails?.phoneNumber}<br/>
                ${pmUserDetails?.emailId}<br/><br/>
                
                <h3>Please do not reply to this email, replies to this message are routed to an unmonitored mailbox.
                If you have any questions please contact ${pmUserDetails?.firstName} ${pmUserDetails?.lastName} (${pmUserDetails?.phoneNumber})</h3>
            </div>
        `,
        attachments: {fileName: "PurchaseOrder.pdf", url: buyerPOPdfURL}
    }

    let POApprovals = useMemo(() => {
        return approvals?.filter(eachApproval => pmCompanyConfig.buyerPOApprovalTypeIds.includes(eachApproval.approvalTypeId))
    }, [approvals])

    const isActiveProfromaInvoiceExists = proformaInvoice?.proformaInvoiceId ? true : false
    
    let {
        notRequestedApprovalExists, 
        pendingApprovalsExist, 
        allApprovalsApproved
    } = getApprovalStatus(approvalRequestStatusDetails)

    if(poPunch?.length > 0){
        pendingApprovalsExist = false
        allApprovalsApproved = true
    }

    const actionMenuItems = [
        {
            label: 'View Doc',
            visible: displayTable ? true : false,
            command: () => {
                window.open(`/buyerpo/${buyerPO.buyerPOId}`, "_blank")
            }
        },
        {
            label: 'PO Punch',
            permissions: [],
            command: () => {
                setVisiblePOPunch(true)
            },
            disabled: isPDFLoading || isLoading || pendingApprovalsExist
        },
        {
            label: isActiveProfromaInvoiceExists ? 'View Proforma Invoice' : 'Create Proforma Invoice',
            command: () => {
                isActiveProfromaInvoiceExists ? window.open(`/proforma_invoice/${proformaInvoice?.proformaInvoiceId}`) : setIsProformaInvoiceVisible(true)
            },
            permissions: [132],
            disabled: isPDFLoading || isLoading || pendingApprovalsExist || buyerPO.statusId === 6
        },
        {
            label: isPDFLoading ? "Loading..."  : 'Download Buyer PO',
            permissions: [13],
            command: () => {
                if(buyerPOPdfURL){
                    downloadFile(buyerPOPdfURL, `buyerPO-${buyerPO?.docNo}.pdf`)
                }
                else{
                    setIsPDFLoading(true)
                    getBuyerPOPDFURL()
                }
            },
            disabled: isPDFLoading || isLoading || pendingApprovalsExist
        },
        {
            label: 'Send Email',
            permissions: [13],
            command: () => setIsEmialDialogVisible(true),
            disabled: isPDFLoading || isLoading || pendingApprovalsExist || buyerPO.statusId === 6 
        },
        {
            label: "Regenerate Document",
            className: "",
            command: () => regenerateDocCopy(),            
            permissions: [102],
            visible: true,
            disabled: isLoading || isPDFLoading
        },
        {
            label: 'Cancel Buyer PO',
            permissions: [14],
            command: () => {
                if (buyerPO?.statusId === 3){
                    setIsReasonDialogVisible(true)
                }
            },
            disabled: buyerPO?.statusId === 6 || isPDFLoading || isLoading,
            className: "cancel-btn"
        }
    ]

    useEffect(()=>{
        getBuyerPO()
        dispatch(fetchCompanySupplyType())
        dispatch(fetchApprovalSecondary())
        dispatch(fetchMaterialBrands())
        dispatch(fetchApprovals())
        dispatch(fetchApprovalTypes())
        dispatch(fetchStatus())
    }, [])

    useEffect(() => {
        if(buyerReq && buyerPO && buyerPOItems.length > 0){
            calculateApprovals()
        }
    }, [buyerReq, buyerPO, buyerPOItems, approvalInstances])

    const calculateApprovals = () => {
        const updatedRequiredApprovals = getBuyerPOApprovals({buyerPO, buyerPOItems, POApprovals, buyerReq})
        setRequiredApprovals(updatedRequiredApprovals)

        const pmBranchId = buyerPO.pmBranchId
        const approvalRequestStatusDetails = getApprovalRequestStatusDetails({updatedRequiredApprovals, approvalInstances, approvals, pmBranchId, buyerPO})
        setApprovalRequestStatusDetails(approvalRequestStatusDetails)
    }

    const handleBuyerPOCancel = async (cancelReason) => {
        const activePOPunchs = poPunch.filter(each => each.buyerPOId === buyerPO.buyerPOId && each.statusId === 1)
        if(activePOPunchs.length === 0){
            if (window.confirm("Are you sure you want to cancel the seller po?")){
                setButtonClicked(true)
                setIsReasonDialogVisible(false)
                const response = await cancelBuyerPO(buyerPOId, {cancellationReason: cancelReason})
                if (response.failure){
                    setButtonClicked(false)
                    return dispatch(raiseToast({severity:'error', summary: "Cancel Buyer PO", detail: response.data.error, life: 3000}))
                }else{
                    dispatch(raiseToast({severity:'warn', detail:'Buyer PO has been Marked as Cancelled.', life: 3000})) 
                    // setIsReasonDialogVisible(false)
                    getBuyerPO()
                    setButtonClicked(false)
                } 
            }
        }else{
            setIsReasonDialogVisible(false)
            return dispatch(raiseToast({severity:'error', detail:'There is an active PO Punch', life: 3000})) 
        }
    }

    const handleProformaInvoice = async () => {
        if (!selectedSupplyTypeId){
            return dispatch(raiseToast({severity:'error', detail: 'Please Select the Supply Type Id.', life: 3000}))
        }

        let updatedBuyerPO = {
            buyerPOId: buyerPO.buyerPOId,
            parentDocNo: buyerPO.docNo,
            parentFileNo: buyerPO.fileNo,
            statusId: 1,
            createdBy: buyerPO.createdBy,
            updatedBy: buyerPO.updatedBy,
            userId: buyerPO.userId,
            companyId: buyerPO.companyId,
            pmCompanyId: buyerPO.pmCompanyId,
            branchId: buyerPO.branchId,
            pmBranchId: buyerPO.pmBranchId,
            pmBillAddrId: buyerPO.pmBillAddrId,
            billAddrId: buyerPO.billAddrId,
            shipAddrId: buyerPO.shipAddrId,
            supplyTypeId: selectedSupplyTypeId
        }
        let data = {
            buyerPO: updatedBuyerPO,
            buyerPOItems, buyerPOItems
        }

        if (window.confirm("Do you want to continue...?")){
            setButtonClicked(true)
            const proformaInvoiceRes = await insertProformaInvoice(data)
            if (proformaInvoiceRes.failure){
                setButtonClicked(false)
                return dispatch(raiseToast({severity:'error', summary: "Proforma Invoice", detail: proformaInvoiceRes.data.error, life: 3000}))
            }
            dispatch(raiseToast({severity:'success', detail: 'Proforma Invoice Generated Succesfully.', life: 3000}))
            setProformaInvoice(proformaInvoiceRes?.data)
            setIsProformaInvoiceVisible(false)
            setButtonClicked(false)
        }
    }

    const regenerateDocCopy = async () => {
        if(!window.confirm("Confirm to regenerate document")){
            return
        }

        setIsLoading(true)

        const createNewDocCopy = true
        const docCopyRes = await getDocCopyByDocNo(buyerPO.docNo, null, createNewDocCopy)

        if(docCopyRes.failure){
            dispatch(raiseToast({severity:'error', detail: docCopyRes.data.error, life: 3000}))
        }else{
            setBuyerPOPDFURL(docCopyRes?.docLocation)
        }

        setIsLoading(false)
    }

    const getBuyerPOPDFURL = async () => {
        setIsPDFLoading(true)

        const docCopyRes = await getDocCopyByDocNo(buyerPO.docNo, true)

        if(docCopyRes.failure){
            setIsPDFLoading(false)
            return dispatch(raiseToast({severity:'error', summary: "Buyer PO Document", detail:docCopyRes.data.error, life: 3000}))
        }
        
        if(!docCopyRes?.docLocation){
            setIsPDFLoading(false)
            return dispatch(raiseToast({severity:'error', summary: "Buyer PO Document", detail: "Buyer PO document was not found.", life: 3000}))
        }

        downloadFile(docCopyRes.docLocation, `buyerPO-${buyerPO?.docNo}.pdf`)
        setIsPDFLoading(false)

        getBuyerPO()
    }

    const handleMenuToggle = (e) => {
        actionMenu.current.toggle(e)
    }

    const handleRemarks = (srNo, text) => {
        const updatedApprovalRequestStatusDetails = approvalRequestStatusDetails.map(eachRequestDetail => {
            if(eachRequestDetail.srNo === srNo){
                return {...eachRequestDetail, remarks: text}
            }
            return eachRequestDetail
        })

        setApprovalRequestStatusDetails(updatedApprovalRequestStatusDetails)
    }

    const handleApprovalRequest = (data) => {
        setApprovalInstances([...approvalInstances, data])
    }

    const handleSendMail = async (emailObj) => {
        const emailRes = await sendEmail({...emailObj, useOrders: true})
        if (emailRes?.failure){
            dispatch(raiseToast({severity:'error', summary: "Send Buyer PO Mail", detail: emailRes?.data?.error, life: 3000}))
        }else{
            dispatch(raiseToast({severity:'success', detail: "Mail has been sent succesfully", life: 3000}))
        }
    }


    const renderHTMLBuyerPODocument = (documentHTML) => {
        const sanitizedHTML = DOMPurify.sanitize(documentHTML)
        return(
            <>
                {Parser(sanitizedHTML)}
            </>
        )
    }

    const renderBuyerPOPDF = (buyerPOPdfURL) => {
        return(
            <div className="document-y-scroll">
                <div style={{ width: '210mm', minHeight: '297mm' }}>
                    <DocumentView fileUrl={buyerPOPdfURL}/>
                </div>
            </div>
        )
    }

    const renderTableStructure = () => {
        return (
            buyerPOItems.length ?
            <div className={`p-card my-2 py-2 buyerpo-modal-data ${buyerPO?.statusId === 6 ? 'cancelled-watermark' : ''} ${buyerPO?.statusId === 4 ? 'force-closed-watermark' : ''}`}>
                <ConfirmPopup />
                <div className="grid">
                    <div className="flex flex-row col-12 justify-content-between pb-0 pt-0">
                        <div className="flex flex-row justify-content-start align-items-center lg:mb-0 pl-0">
                            <h5 className="m-0 quote-number doc-no-navigation" onClick={() => window.open(`/buyerpo/${buyerPO?.buyerPOId}`)}> <span style={{ fontWeight: "lighter" }}>Buyer PO No:</span> {buyerPO?.docNo}</h5>
                            {
                                buyerPO?.docNo ? <CopyToClipboard text={buyerPO?.docNo} /> : ""
                            }
                            {selectedReq?.isRouted ? <h5 className="m-0 pl-1 doc-no-navigation">ROUTED</h5> : null}
                        </div>
                        <div className="flex flex-row justify-content-start align-items-center lg:mb-0 pl-0">
                            <h5 className="m-0 quote-number doc-no-navigation" onClick={() => window.open(`/buyer/quotation/${buyerQuote[0].buyerQuoteId}`)}> <span style={{ fontWeight: "lighter" }}>Quote No:</span> {buyerQuote[0]?.docNo}</h5>
                            {
                                buyerQuote[0]?.docNo ? <CopyToClipboard text={buyerQuote[0].docNo} /> : ""
                            }
                        </div>
                        <div className="flex flex-row mb-2 lg:mb-0 align-items-center justify-content-center">
                            <div><span>Client PO Num:</span>&nbsp;&nbsp;<span className="price-value">{buyerPO?.clientPONum}</span></div>
                        </div>
                        <div className="flex justify-content-end align-items-center mb-2 mt-1">
                            <Button className={`h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${approvalIconColour}`} rounded onClick={() => setVisibleApprovals(true)} disabled={isLoading || !approvalRequestStatusDetails.length} >
                                <i className={isLoading ? "pi pi-spin pi-spinner" : approvalsIcon} style={{ fontSize: "0.9rem", cursor: "pointer" }} />
                            </Button>
                            <div>
                                <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                                <Button className="ml-2" rounded onClick={handleMenuToggle} disabled={isLoading} >
                                    <i className={isLoading ? "pi pi-spin pi-spinner" : "pi pi-ellipsis-h"} style={{ fontSize: "0.9rem", cursor: "pointer" }} />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="custom-table-container">
                    <table className="custom-product-table" style={{ width: "100%" }}>
                        <thead>
                            <tr className="">
                                <th className="" >SR</th>
                                <th className="" >PRODUCT</th>
                                <th className="" >SPECIFICATION</th>
                                <th className="" >LEAD TIME</th>
                                <th className="" >QUANTITY</th>
                                <th className="" >UNITPRICE</th>
                                <th className="" >GSTRATE</th>
                                <th className="" >AMOUNT</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                            {
                                buyerPOItems?.map((eachBuyerPOItem, index) => {
                                    const relatedMaterial = materialDetails.find(eachMaterial => eachMaterial.buyerReqItemId === eachBuyerPOItem.buyerReqItemId)
                                    const relatedBrand = materialBrands.find(eachBrand => eachBrand.brandId === relatedMaterial?.brandId)

                                    return (
                                        <tr key={`buyerPOItem-${eachBuyerPOItem.buyerPOItemId}`} className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                            <td className="">{index + 1}</td>
                                            <td className="">{getProductName(relatedBrand?.brandName, relatedMaterial?.productName, relatedMaterial?.variantName)}</td>
                                            <td className="">{getProductSpecification(relatedMaterial?.productSpecification, relatedMaterial.UOM, relatedMaterial.UOMValue)}</td>
                                            <td className="">{eachBuyerPOItem.leadTime} Day(s)</td>
                                            <td className="">{getProductQty(eachBuyerPOItem?.bPOQty, relatedMaterial?.UOM, relatedMaterial?.UOMValue)}</td>
                                            <td className="">{currencyShortName}.{numberConversion(eachBuyerPOItem?.bPOUnitPrice, numberLocale)}</td>
                                            <td className="">{eachBuyerPOItem?.bPOGSTRate}%</td>
                                            <td className="">{numberConversion(eachBuyerPOItem?.bPOItemAmountWithTax, numberLocale)}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    <div className="flex flex-row justify-content-end mt-2">
                        <div>
                            <span>Total Amount:</span>&nbsp;&nbsp;<span className="price-value">{numberConversion(parseFloat(buyerPO?.bPOTotalAmountWithTax), numberLocale)}</span>
                        </div>
                    </div>
                </div>
            </div>
            :
            null
        )
    }

    const renderDocumentStructure = () => {
        return (
            <div className="mb-0 document-page-container">
                <div className="flex flex-column md:flex-row md:justify-content-between">
                    <h4 className="mt-2 mb-0">BUYER PO {buyerReq?.buyerReqId && (buyerReq?.isRouted ? ` - ROUTED` : ` - NOT ROUTED`)}</h4> 
                    <div className="flex justify-content-end mt-2 md:mt-0">
                        <div className="flex justify-content-end mb-2 ml-2 mr-2">
                            <Button className={`h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${pendingApprovalsExist && "red-text"} ${allApprovalsApproved && "green-text"}`} label="Approvals" onClick={() => setVisibleApprovals(true)} disabled={!approvalRequestStatusDetails.length} />
                        </div>
                        <div className="flex justify-content-end mb-2">
                            <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                            <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={handleMenuToggle} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    let updatedCompanySupplyTypes = []
    companySupplyTypes?.map(eachCompanySupplyType => {
        if ([1, 2, 3, 4].includes(eachCompanySupplyType?.supplyTypeId)){
            let updatedCompanySupplyType = {...eachCompanySupplyType, label: 'supplyType', value: 'supplyTypeId'}
            updatedCompanySupplyTypes.push(updatedCompanySupplyType)
        }
    })
    updatedCompanySupplyTypes = _.sortBy(updatedCompanySupplyTypes, "supplyTypeId")

    let approvalsIcon = 'pi pi-check'
    let approvalIconColour = "green-text"

    if (pendingApprovalsExist){
        approvalsIcon = "pi pi-hourglass"
        approvalIconColour = "yellow-text"
    }
    if (notRequestedApprovalExists){
        approvalsIcon = 'pi pi-times'
        approvalIconColour = "red-text"
    }
    if (allApprovalsApproved){
        approvalsIcon = "pi pi-check"
        approvalIconColour = "green-text"
    }

    return (
        <>
            {
                displayTable ? 
                renderTableStructure()
                : 
                renderDocumentStructure()
            }
            <Loading visible={buttonClicked}/>
            <RemarksDialog visible={isReasonDialogVisible} onHide={() => setIsReasonDialogVisible(current => !current)} onSubmit={handleBuyerPOCancel}/>
            <SendEmail emailDetailsObj={emailDetailsObj} handleSendMail={handleSendMail} visible={isEmailDialogVisible} onHide={() => setIsEmialDialogVisible(current => !current)}/>

            <Dialog header="Approvals" className="approvals-dialog" visible={visibleApprovals} onHide={() => setVisibleApprovals(false)} style={{ width: '80vw',height: '80vh' }} >
                {/* <ApprovalsDisplay
                    buyerPO={buyerPO}
                    buyerPOItems={buyerPOItems}
                    approvalInstances={approvalInstances}
                    POApprovals={POApprovals}
                    approvalSecondary={approvalSecondary}
                    materialDetails={materialDetails}
                    approvalRequestStatusDetails={approvalRequestStatusDetails}
                    setApprovalRequestStatusDetails={setApprovalRequestStatusDetails}
                    buyerPOId={buyerPOId}
                    buyerReq={buyerReq}
                    buyerQuote={buyerQuote}
                    isDoc={true}
                    handleRemarks={handleRemarks}
                    handleApprovalRequest={handleApprovalRequest}
                /> */}
                <NewApprovalsDisplay
                    buyerPO={buyerPO}
                    buyerPOItems={buyerPOItems}
                    approvalTypes={approvalTypes}
                    approvalInstances={approvalInstances}
                    POApprovals={POApprovals}
                    approvalSecondary={approvalSecondary}
                    materialDetails={materialDetails}
                    approvalRequestStatusDetails={approvalRequestStatusDetails}
                    setApprovalRequestStatusDetails={setApprovalRequestStatusDetails}
                    buyerPOId={buyerPOId}
                    buyerReq={buyerReq}
                    buyerQuote={buyerQuote}
                    isDoc={true}
                    handleRemarks={handleRemarks}
                    handleApprovalRequest={handleApprovalRequest}
                />
            </Dialog>
            
            <Dialog header="PO Punch" className="po-punch-dialog" visible={visiblePOPunch} style={{ width: '85vw', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={() => setVisiblePOPunch(false)}>
                <POPunch buyerPOId={buyerPOId} />
            </Dialog>
            {!isLoading && !displayTable ?
                    (buyerPOPdfURL ? renderBuyerPOPDF(buyerPOPdfURL) : <div className={buyerPO?.statusId === 6 && "cancelled-watermark"}>{renderHTMLBuyerPODocument(documentHTML)}</div>
                    ) : null
            }
            <Dialog header="Create Proforma Invoice" visible={isProformaInvoiceVisible} style={{ width: '35vw', height: '45vh' }} onHide={() => {setIsProformaInvoiceVisible(false); setSelectedSupplyTypeId(null)}}>
                <div className='flex flex-row col-12 pb-0 justify-content-between'>
                    <div className='flex flex-column col-12'>
                        <p className="">Supply Types</p> 
                        {
                            updatedCompanySupplyTypes?.map(eachCompanySupplyType => {
                                return (
                                    <div className='flex flex-row mt-2'>
                                        <RadioButton inputId={eachCompanySupplyType?.supplyTypeId} name="pdfType" value={eachCompanySupplyType?.supplyTypeId} checked={eachCompanySupplyType?.supplyTypeId === selectedSupplyTypeId} onChange={() => setSelectedSupplyTypeId(eachCompanySupplyType?.supplyTypeId)}/>
                                        <label htmlFor={eachCompanySupplyType?.supplyTypeId} className="p-radiobutton-label">{eachCompanySupplyType?.supplyType}</label>
                                    </div>
                                )
                            })
                        }
                        <div className='flex flex-row justify-content-center' style={{marginTop: '2rem'}}>
                            <Button label="Create Proforma Invoice" onClick={handleProformaInvoice} />
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default BuyerPOView;